import { render, staticRenderFns } from "./mode.vue?vue&type=template&id=7126a631&scoped=true"
import script from "./mode.vue?vue&type=script&lang=js"
export * from "./mode.vue?vue&type=script&lang=js"
import style0 from "./mode.vue?vue&type=style&index=0&id=7126a631&prod&lang=css"
import style1 from "./mode.vue?vue&type=style&index=1&id=7126a631&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7126a631",
  null
  
)

export default component.exports